import { Moment } from 'moment';

export const intervalOptions = [
  {
    value: 'today',
    label: 'general.lists.interval.option-today',
  },
  {
    value: 'lastHours_6',
    label: 'general.lists.interval.option-last-6-hours',
  },
  {
    value: 'lastHours_12',
    label: 'general.lists.interval.option-last-12-hours',
  },
  {
    value: 'yesterday',
    label: 'general.lists.interval.option-yesterday',
  },
  {
    value: 'lastDays_2',
    label: 'general.lists.interval.option-last-2-days',
  },
];

export const granularityOptions = [
  {
    value: '1m',
    label: 'general.lists.granularity.option-1-m',
  },
  {
    value: '5m',
    label: 'general.lists.granularity.option-5-m',
  },
  {
    value: '10m',
    label: 'general.lists.granularity.option-10-m',
  },
  {
    value: '15m',
    label: 'general.lists.granularity.option-15-m',
  },
  {
    value: '30m',
    label: 'general.lists.granularity.option-30-m',
  },
  {
    value: '1h',
    label: 'general.lists.granularity.option-1-h',
  },
  {
    value: '2h',
    label: 'general.lists.granularity.option-2-h',
  },
  {
    value: '3h',
    label: 'general.lists.granularity.option-3-h',
  },
  {
    value: '4h',
    label: 'general.lists.granularity.option-4-h',
  },
  {
    value: '8h',
    label: 'general.lists.granularity.option-8-h',
  },
  {
    value: '12h',
    label: 'general.lists.granularity.option-12-h',
  },
  {
    value: '24h',
    label: 'general.lists.granularity.option-24-h',
  },
];

export interface DateLabel {
  from: Moment;
  to: Moment;
}

export interface TableChartValue {
  id: number;
  value: any;
  time: string;
}

export interface TableChartDataset {
  data: any;
  name: string;
  isPlan?: boolean;
}
